import { FC } from 'react';
import type { QuotedTileData } from 'state/quotes/dashboard/model';

import { Price, PricingDate, ResultPanel, SolveModeLabel, TileLayout } from './components';
import type { TileContentProps } from './Tile.common';

export const QuotedTile: FC<TileContentProps<QuotedTileData>> = ({ header, subHeader, footer, data }) => {
  const resultPanelColor = data.isTradeable ? 'info' : 'success';

  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color={resultPanelColor}
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="normal" />}
        price={
          <Price
            solveResult={data.solveResult}
            solveResultFormat={data.solveResultFormat}
            xMargin={data.xMargin}
            color={resultPanelColor}
          />
        }
        subHeader={<PricingDate when={data.lastUpdated} />}
      />
    </TileLayout>
  );
};

QuotedTile.displayName = 'QuotedTile';
